import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { OrderDetailPage } from '@/features/service-agreements/order-detail-page';

export const Route = createFileRoute('/_app/service-agreement/orders/$orderId')({
  staticData: { featureKey: 'service-agreements' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'service-agreements',
      permissions: ['service-agreement:read'],
    }),
  component: OrderDetail,
});

function OrderDetail() {
  const { orderId } = Route.useParams();
  return <OrderDetailPage orderId={orderId} />;
}
